import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  cwMonochrome: {
    width: 260,
    height: 260,
    d: `M130,0A130,130,0,1,0,260,130,130,130,0,0,0,130,0ZM108.26,106.44H73.91l.24,0a26.26,26.26,0,0,0,0,52.52h34.11v29.56H73.91a55.81,55.81,0,0,1,0-111.61h34.35ZM148.73,208l27-29.43,27,29.43Zm53.15-19.52-26.16-28.56-26.17,28.54-26.68,0V76.52h27.7v72.72l25.1-27.48,25.19,27.47V76.52h27.7V188.45Z`,
  },
});
